import React, { useCallback, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";

// BigCalendar.js

function BigCalendar({ events, handleDateSetChange, handleDateClick }) {
  const onDateSet = useCallback(
    (dateInfo) => {
      const viewStart = dateInfo.view && dateInfo.view.currentStart;
      const viewEnd = dateInfo.view && dateInfo.view.currentEnd;
      const startVal = viewStart || dateInfo.startStr;
      const endVal = viewEnd || dateInfo.endStr;
      const start = startVal ? moment(startVal) : null;
      const end = endVal ? moment(endVal) : null;

      const formattedStart =
        start && start.isValid() ? start.format("YYYYMMDD") : null;
      const formattedEnd = end && end.isValid() ? end.format("YYYYMMDD") : null;
      let queryMonth = null;
      if (start && start.isValid()) {
        queryMonth = start.format("YYYYMM");
      } else if (end && end.isValid()) {
        queryMonth = end.format("YYYYMM");
      }
      handleDateSetChange(formattedStart, formattedEnd, queryMonth);
    },
    [handleDateSetChange]
  );

  useEffect(() => {
    const elems = document.querySelectorAll(".fc-daygrid-day.fc-day");
    elems.forEach((elem) => {
      if (elem.classList.contains("event-calender-item")) {
        elem.classList.remove("event-calender-item");
      }
    });
  }, [events]);

  return (
    <>
      <div className="cal-state-wrap">
        <p className="cal-state-classDate">
          <span></span>수업일
        </p>
      </div>
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        headerToolbar={{
          left: "", //dayGridWeek,dayGridMonth
          center: "prev,title,next",
          right: "",
        }}
        showNonCurrentDates={true}
        observeChanges={true}
        locale="ko"
        initialView={"dayGridMonth"}
        dateClick={handleDateClick}
        datesSet={onDateSet}
        events={events}
        height="parent"
        allDaySlot={true}
        // eventContent={function (event) {
        //     return <div className="event-contents" ref={eventContents}></div>;
        // }}
        eventDidMount={function (event) {
          event.el.parentNode.parentNode.parentNode.parentNode.classList.add(
            "event-calender-item"
          );
        }}
        dayCellContent={(args) => {
          return moment(args.date).format("D");
        }}
      />
    </>
  );
}

export default BigCalendar;
